import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import theme from 'config/theme';
import i18n from 'config/i18n';
import history from 'config/history';
import 'index.css';
import App from 'components/App/App';
import store from './redux_store/store';
import NavigationInitializer from './redux_store/components/NavigationInitializer';
import NotificationsProvider from './contexts/NotificationsProvider';
import ClientProvider from './contexts/ClientProvider';
import UserProvider from './contexts/UserProvider';
import CacheBuster from './CacheBuster';

console.warn = console.error = () => {};

// Suppress ResizeObserver errors in development
if (process.env.NODE_ENV === 'development') {
  const debounce = (callback, delay) => {
    let tid;
    return function (...args) {
      const ctx = this;
      clearTimeout(tid);
      tid = setTimeout(() => callback.apply(ctx, args), delay);
    };
  };

  // Create error handler
  const errorHandler = debounce((e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded') {
      e.stopImmediatePropagation();
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, 0);

  window.addEventListener('error', errorHandler);
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message &&
        (e.reason.message.includes('ResizeObserver loop completed') ||
         e.reason.message.includes('ResizeObserver loop limit'))) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });
}

ReactDOM.render(
  <>
    <CssBaseline />
    <MuiThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <NotificationsProvider>
          <Provider store={store}>
            <ClientProvider>
              <BrowserRouter history={history}>
                <NavigationInitializer>
                  <UserProvider>
                    <CacheBuster>
                      <App />
                    </CacheBuster>
                  </UserProvider>
                </NavigationInitializer>
              </BrowserRouter>
            </ClientProvider>
          </Provider>
        </NotificationsProvider>
      </I18nextProvider>
    </MuiThemeProvider>
  </>,
  document.getElementById('root')
);
